export default function QuoteSection() {
  return (
    <section className="relative py-20 md:py-28 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-3xl mx-auto text-center">
          <blockquote className="text-xl sm:text-2xl md:text-3xl font-semibold text-white leading-snug">
            StackMap is not just software. It is the{" "}
            <span className="text-emerald-accent">operational infrastructure</span>{" "}
            required to scale.
          </blockquote>
          <div className="mt-8 flex items-center justify-center gap-2">
            <div className="w-12 h-px bg-graphite-700" />
            <div className="w-2 h-2 rounded-full bg-emerald-accent" />
            <div className="w-12 h-px bg-graphite-700" />
          </div>
        </div>
      </div>
    </section>
  );
}